<template>
  <div ref="el" style="user-select: none">
    <div
      v-if="isMobile || isWindow"
      style="overflow: hidden; text-align: center"
    >
      <slot />
    </div>
    <div
      v-else
      class="login-layout-container"
      style="position: absolute; left: 0; top: 0; overflow: hidden"
    >
      <LoginHeader v-if="isCustomImage" :logo="headLogo as string" />
      <LoginHeader v-else :logo="props.headLogo" />
      <div class="tip-box">
        <div class="tip">一体化智能零售云服务提供商</div>
        <div class="sub-tip">
          助力企业
          <div class="blue">提效降本，规模化发展</div>
        </div>
      </div>
        <div class="bg-container" v-if="isCustomImage" >
            <img  :src="bgImg" alt="img" width="760"/>
        </div>
        <div class="bg-container" v-else >
            <img  :src="props.bgImg" alt="img" width="760"/>
        </div>
      <div style="position: absolute; left: 55%; top: 20%">
        <slot />
      </div>
    </div>
  </div>
  <slot name="riskDialog" />
</template>
<script lang="ts" setup>
import LoginHeader from '@/components/LoginHeader.vue'
import {catchError, deviceDetection, urlParams} from '@/utils'
import { useResizeObserver } from '@vueuse/core'
import {getSkin} from 'api/LoginAPI'

const props = defineProps<{
  headLogo: string
  bgImg: string
  bgColor: string
  wrapperSize: string
  isHjy: boolean
}>()

const el = ref(null)
const isMobile = ref(deviceDetection())
const hash = location.href as string
const urlData = urlParams(hash.slice(hash.indexOf('?'))) as any
const isWindow = ref(urlData['_raw'] === 'main')
import background from '../../../assets/background.png'
//是否是自定义图片
const isCustomImage  = ref(false)

const bgImg = ref("")
const headLogo = ref<string>("")

const backgroundImgTep = ref("")
const bgImgTep = ref("")
const headLogoTep = ref("")


/**
 * 加载背景图片
 */
const loadBackgroundImage = async () => {
    await getSkinFun()
    if(isCustomImage.value){
        await setBackgroundImage(backgroundImgTep.value,bgImgTep.value,headLogoTep.value)
    }

}

/**
 * 获取皮肤图片
 */
const getSkinFun = async() => {
    const hashUrl = location.href as string
    const hashData = urlParams(hashUrl.slice(0,hashUrl.indexOf('#')))
    let productId = props.isHjy? "hjy" : Array.isArray(hashData.productID)? hashData.productID[0] : hashData.productID
    let {response, error} = await catchError(
        getSkin(
            {
                src: Array.isArray(hashData.src)? hashData.src[0] : hashData.src,
                productId: productId
            },
            5000
        )
    )
    if(error){
        isCustomImage.value = false
    }else{
        if(response?.code != 0){
            isCustomImage.value = false
            return
        }
        backgroundImgTep.value = (response?.data as any).background;
        bgImgTep.value = (response?.data as any).bgImg;
        headLogoTep.value = (response?.data as any).headLogo;
        isCustomImage.value = true
    }
}

/**
 * 设置背景图片
 * @param backgroundImgPar 背景图片
 * @param bgImgPar 背景大图
 * @param headLogoPar logo
 */
const setBackgroundImage = async (backgroundImgPar,bgImgPar,headLogoPar)=>{
    const images = [
        {  src: backgroundImgPar ,name :"backgroundImg"},
        {  src: bgImgPar ,name :"bgImg"},
        {  src: headLogoPar ,name :"headLogo"}
    ];
    Promise.all(images.map(url =>{
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = url.src;
            image.onload = () => resolve({ ...url, image }); // 图片加载完成
            image.onerror = () =>reject({ ...url, image }); // 图片加载失败
        });
    }))
        .then((res:any) => {
            res.forEach(item=>{
                if("bgImg" == item.name){
                    bgImg.value = item.src
                }
                else if("headLogo" == item.name){
                    headLogo.value = item.src
                }else{
                    let element = <HTMLElement>document.querySelector('.login-layout-container') ;
                    element.style.backgroundImage = `url(${item.src})`;
                }
            })
            isCustomImage.value = true
        })
        .catch(error => {
            // 任意一张图片加载失败，处理错误情况
            // console.log("调试数据,错误信息：",error)
            let element = <HTMLElement>document.querySelector('.login-layout-container');
            //默认背景图片
            element.style.backgroundImage = `url(${background})`;
            headLogo.value = props.headLogo
            bgImg.value = props.bgImg
            isCustomImage.value = false
        });

}

onMounted(() => {
    loadBackgroundImage()
})
useResizeObserver(el, (entries) => {
  isMobile.value = deviceDetection()
})
</script>
<style lang="scss" scoped>
.login-layout-container {
  height: 100%;
  width: 100%;
  background: url('../../../assets/background.png') center/cover no-repeat;

  .tip-box {
    position: absolute;
    top: 17%;
    left: 18%;

    .tip {
      font-size: 36px;
      font-weight: 500;
      color: #303133;
      line-height: 50px;
    }

    .sub-tip {
      display: flow;
      margin-top: 16px;
      font-size: 22px;
      font-weight: 500;
      color: #606266;
      line-height: 30px;

      .blue {
        display: inline-block;
        color: #3d8eff;
      }
    }
  }

  .bg-container {
    position: absolute;
    top: 30%;
    left: 10%;
  }
}
</style>
